import React, { useState, useEffect, useCallback } from "react";
import { injectIntl } from "react-intl";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";
import { Field, reduxForm } from "redux-form";
import Form from 'react-bootstrap/Form';
import { connect } from "react-redux";
import Loader from "../Common/Loader/Loader";
import InputFieldComponent from "../Common/InputFieldComponent/InputFieldComponent";
import SelectFieldComponent from "../Common/SelectFieldComponent/SelectFieldComponent";

import validate from "./validate"
import { submit } from "./submit";
import { api, countryFlagImageDir } from "../../config";
import messages from "../../locale/messages";
import bt from '../../components/commonStyle.css';
import s from "./EditProfileForm.css"



function EditProfileForm(props) {
    const {
        handleSubmit,
        initialValues,
        currencyList,
        loading,
        error,
        change,
        referralCode,
        intl: { formatMessage }
    } = props

    const [flagImage, setFlagImage] = useState('')

    useEffect(() => {
        if (initialValues?.phoneNumber && initialValues?.phoneDialCode) {
            const phoneNumber = initialValues.phoneDialCode + "" + initialValues.phoneNumber;
            if (initialValues.flagImage) {
                setFlagImage(initialValues.flagImage);
            }
            change("phoneNumber", phoneNumber);
        }
    }, []);

    useEffect(() => {
        if (initialValues?.phoneNumber && initialValues?.phoneDialCode) {
            const phoneNumber = initialValues.phoneDialCode + " " + initialValues.phoneNumber;
            if (initialValues.flagImage) {
                setFlagImage(initialValues.flagImage);
            }
            change("phoneNumber", phoneNumber);
        }
    }, [initialValues]);

    const handleChange = () => { }

    const currencyOptions = currencyList && currencyList?.length > 0 && currencyList?.filter(item => item?.isEnable).map(item => {
        return {
            value: item?.symbol,
            label: item?.symbol
        }
    })

    return (
        <div className={s.editProfileSectionWrapper}>
            <p className={s.editProfilesTitle}>{formatMessage(messages.editProfile)}</p>
            <form onSubmit={handleSubmit(submit)} >
                {error && <span>{formatMessage(error)}</span>}
                <div className='twoColumnGrid'>
                    <Field
                        name="firstName"
                        type="text"
                        component={InputFieldComponent}
                        label={formatMessage(messages.firstNameText)}
                        placeholder={formatMessage(messages.firstNameText)}
                        maxLength={20}
                        inputClass={bt.formControlInput}
                    />
                    <Field
                        name="lastName"
                        type="text"
                        component={InputFieldComponent}
                        label={formatMessage(messages.lastNameText)}
                        placeholder={formatMessage(messages.lastNameText)}
                        maxLength={20}
                        inputClass={bt.formControlInput}
                    />
                    <Field
                        name="phoneNumber"
                        type="text"
                        component={InputFieldComponent}
                        label={formatMessage(messages.mobileNumber)}
                        placeholder={formatMessage(messages.mobileNumber)}
                        isAddon
                        noColor
                        prefixLabel={<img src={`${api.apiEndpoint}${countryFlagImageDir}${flagImage}`} width="18" height="12" alt="flag" />
                        }
                        disabled={true}
                        normalize={handleChange}
                    />
                    <Field
                        name="email"
                        type="text"
                        component={InputFieldComponent}
                        label={formatMessage(messages.emailText)}
                        placeholder={formatMessage(messages.emailText)}
                        disabled={true}
                        inputClass={bt.formControlInput}
                    />
                    <Field
                        name="preferredCurrency"
                        component={SelectFieldComponent}
                        options={currencyOptions}
                        label={formatMessage(messages.preferredCurrency)}
                        inputClass={bt.formControlSelect}
                    />
                    {referralCode ? (
                        <div style={{ background: '#FFF6F4', border: '1px solid #f1d3cb', borderRadius: 12, padding: 18, marginTop: 12, fontFamily: 'Poppins, sans-serif' }}>
                            <div style={{ fontWeight: 700, color: '#1F2733' }}>Your referral code</div>
                            <div style={{ fontSize: 26, fontWeight: 800, letterSpacing: 2, color: '#D32F2F', margin: '8px 0' }}>{referralCode}</div>
                            <div style={{ fontSize: 13, color: '#666' }}>Share your code — earn rewards when friends sign up and complete their first job.</div>
                            <div style={{ display: 'flex', gap: 10, marginTop: 12 }}>
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (typeof navigator !== 'undefined' && navigator.clipboard) {
                                            navigator.clipboard.writeText(referralCode);
                                            alert('Referral code copied');
                                        }
                                    }}
                                    style={{ flex: 1, padding: '10px 14px', borderRadius: 10, border: '1px solid #D32F2F', background: '#fff', color: '#D32F2F', fontWeight: 700, cursor: 'pointer' }}>
                                    Copy code
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        const msg = `Join me on BestHand! Use my referral code ${referralCode} when you sign up and we both earn rewards. https://besthandapp.com`;
                                        if (typeof navigator !== 'undefined' && navigator.share) {
                                            navigator.share({ title: 'BestHand referral', text: msg }).catch(() => {});
                                        } else if (typeof navigator !== 'undefined' && navigator.clipboard) {
                                            navigator.clipboard.writeText(msg);
                                            alert('Invite message copied — paste it to share');
                                        }
                                    }}
                                    style={{ flex: 1, padding: '10px 14px', borderRadius: 10, border: 'none', background: '#D32F2F', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>
                                    Share
                                </button>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className={s.editProfileBtnGrp}>
                    <Loader
                        type={"button"}
                        buttonType={"submit"}
                        show={loading}
                        label={formatMessage(messages.saveLabel)}
                        className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                    />
                </div>
            </form >
        </div>
    )
}
EditProfileForm = reduxForm({
    form: "EditProfileForm",
    validate
})(EditProfileForm)

const mapState = (state) => ({
    initialValues: state.userAccount.data,
    currencyList: state.currency.availableCurrencies,
    loading: state.loader.updateUserProfile
})
const mapDispatch = {

}

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(EditProfileForm)))